import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

/**
 * Language switcher for the new topbar, and the one place that owns the language selection (the
 * baPageTop copy of this is no longer rendered anywhere). Same lang list, same body.rtl toggling
 * and same 'lang' localStorage key as baPageTop.component.ts, so a session carries over; the
 * default-language handling deliberately differs - see the constructor. Keeps using Bootstrap's
 * data-bs-toggle="dropdown" (already a global script, consistent with the rest of the app).
 */
@Component({
    selector: 'app-shell-lang-switcher',
    templateUrl: './app-shell-lang-switcher.component.html',
    styleUrls: ['./app-shell-lang-switcher.component.scss'],
})
export class AppShellLangSwitcherComponent {
    selectedLanguage = '';

    constructor(public readonly translate: TranslateService) {
        translate.addLangs(['en', 'ar']);
        // 'en' is the fallback, not the selection: ar.json and en.json each cover only about half
        // of the menu titles they are keyed on, and setDefaultLang(the persisted language) - as
        // this used to do - made Arabic the fallback for a session that started in Arabic. Switching
        // to English then resolved every key missing from en.json out of ar.json, so Arabic screen
        // names leaked into the English UI. A fixed English fallback leaves an untranslated key
        // rendering as itself, which is already English text.
        translate.setDefaultLang('en');
        const language = localStorage.getItem('lang') ? 'ar' : 'en';
        this.setSelectedLanguage(language);
        // use(), not just setDefaultLang(): it is what makes translate.currentLang defined from the
        // first render, and MenuSearchService keys its cache off currentLang.
        translate.use(language);
        if (language === 'ar') {
            jQuery('body').addClass('rtl');
        }
    }

    setLanguage(item: string): void {
        if (item === 'ar') {
            if (!jQuery('body').hasClass('rtl')) {
                jQuery('body').addClass('rtl');
                localStorage.setItem('lang', JSON.stringify(item));
            }
        } else {
            jQuery('body').removeClass('rtl');
            localStorage.removeItem('lang');
        }
        this.setSelectedLanguage(item);
        this.translate.use(item);
    }

    private setSelectedLanguage(language: string): void {
        this.selectedLanguage = language === 'ar' ? 'العربية' : 'English';
    }
}
